<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-job-position-job-group-dialog-create
          v-if="$hasPermissionTo(['create job groups'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Job Group's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in job group value here"
          append-icon="search"
          label="Search Job Group"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <!-- do not remove the border='' below -->
    <!-- css purpose -->
    <v-data-table
      border=""
      :headers="headers"
      :items="filteredJobGroups"
      :loading="tableLoading"
      :search="search"
      show-expand
      :single-expand="true"
      class="remove-box-shadow"
    >
      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-job-position-job-group-dialog-edit
            v-if="$hasPermissionTo(['update job groups'])"
            :job-group="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-job-position-job-group-dialog-delete
            v-if="$hasPermissionTo(['delete job groups'])"
            :job-group="item"
            @deleted="loadData"
          /> 
        </span>
        <span v-else>
          <setup-job-position-job-group-dialog-restore
            v-if="$hasPermissionTo(['restore job groups'])"
            :job-group="item"
            @restored="loadData"
          />
        </span>
      </template> 

      <template v-slot:expanded-item="{ headers,item }">
        <td
          :colspan="headers.length"
          class="py-2"
          style="background-color: rgba(0, 0, 0, .05);"
        >
          <v-chip
            v-for="leave_entitlement_setting in item.job_group_leave_entitlement_settings"
            :key="leave_entitlement_setting.id"
            small
            class="text--primary mx-1 my-1"
          >
            {{ leave_entitlement_setting.leave_entitlement_setting.name }}
          </v-chip>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobGroupDialogCreate: () => import('@/components/hris/setup/job-position/job-group/DialogCreate'),
      SetupJobPositionJobGroupDialogEdit: () => import('@/components/hris/setup/job-position/job-group/DialogEdit'),
      SetupJobPositionJobGroupDialogDelete: () => import('@/components/hris/setup/job-position/job-group/DialogDelete'),
      SetupJobPositionJobGroupDialogRestore: () => import('@/components/hris/setup/job-position/job-group/DialogRestore'),
    },
    data () {
      return {
        jobGroups: [],
        trashedJobGroups: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredJobGroups () {
        return this.statusFilter ? this.jobGroups : this.trashedJobGroups
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.jobGroups().list(),
          this.$api.jobGroups().listTrashed(),
        ]).then(([jobGroups, trashedJobGroups]) => {
          this.jobGroups = jobGroups.data
          this.trashedJobGroups = trashedJobGroups.data

          this.tableLoading = false
        })
      },
    },
  }
</script>

<style scoped>
.remove-box-shadow >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__content{
  box-shadow: unset !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row{
  background-color: rgba(0, 0, 0, .05) !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row .text-start{
  border:0px !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row .text-left{
  border:0px !important;
}
</style>
